import { useState, useEffect } from "react";
import { $getSelection, $isRangeSelection } from "lexical";

import { INSERT_ORDERED_LIST_COMMAND, INSERT_UNORDERED_LIST_COMMAND } from "@lexical/list";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { FORMAT_TEXT_COMMAND } from "lexical";
import { TOGGLE_LINK_COMMAND } from "@lexical/link";

export function ToolbarPlugin() {
	const [editor] = useLexicalComposerContext();

	const [isBold, setIsBold] = useState(false);
	const [isItalic, setIsItalic] = useState(false);

	useEffect(() => {
		return editor.registerUpdateListener(({ editorState }) => {
			editorState.read(() => {
				const selection = $getSelection();
				if (!$isRangeSelection(selection)) {
					setIsBold(false);
					setIsItalic(false);
					return;
				}

				setIsBold(selection.hasFormat("bold"));
				setIsItalic(selection.hasFormat("italic"));
			});
		});
	}, [editor]);

	const applyFormat = (command, value) => {
		editor.dispatchCommand(command, value);
	};

	return (
		<div className="d-flex flex-wrap gap-2 mb-2">
			<button
				type="button"
				onClick={() => applyFormat(FORMAT_TEXT_COMMAND, "bold")}
				className={`btn btn-sm ${isBold ? "btn-primary" : "btn-light"}`}
			>
				Bold
			</button>
			<button
				type="button"
				onClick={() => applyFormat(FORMAT_TEXT_COMMAND, "italic")}
				className={`btn btn-sm ${isItalic ? "btn-primary" : "btn-light"}`}
			>
				Italic
			</button>
			<button type="button" onClick={() => applyFormat(INSERT_UNORDERED_LIST_COMMAND)} className="btn btn-sm btn-light">
				Bullets
			</button>
			<button type="button" onClick={() => applyFormat(INSERT_ORDERED_LIST_COMMAND)} className="btn btn-sm btn-light">
				Numbered
			</button>
			<button
				type="button"
				onClick={() => {
					const url = prompt("Enter URL:");
					if (url) {
						editor.dispatchCommand(TOGGLE_LINK_COMMAND, url);
					}
				}}
				className="btn btn-sm btn-light"
			>
				Link
			</button>
		</div>
	);
}
